import { ReactNode } from 'react';

import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import {
   ActionEventInterceptor,
   dispatchSnackbarPositiveEvent,
   PreventPrompt,
   useHistoryPushWithBackAction,
} from '@dreryk/react-components';
import { replaceParams } from '@dreryk/drerykweb-main-frontend';
import { performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

import { translationKeys } from '../translations';

// TODO: DREGAB-24503 Refactor desktop navigation
const TEMPORARY_PATIENT_PATH = '/pacjenci/tymczasowy/:patientId';
const getTemporaryPatientFilePath = (patientId: number): string =>
   replaceParams(TEMPORARY_PATIENT_PATH, {
      patientId: patientId.toString(),
   });
type PatientFileLocationStateData = {
   showAppointmentOutOfSchedule: boolean;
   appointmentId: number | undefined;
};

type PatientDataUpdateBeforeVisitEventInterceptorProps = {
   readonly children: ReactNode;
   readonly patientId: number;
   readonly appointmentId?: number;
   readonly goBackButtonLabel: TranslatableText;
};

export const PatientDataUpdateBeforeVisitEventInterceptor = (
   props: PatientDataUpdateBeforeVisitEventInterceptorProps
): JSX.Element => {
   // TODO DREGAB-3375 Return the ShowModalEventInterceptor logic
   const push = useHistoryPushWithBackAction<PatientFileLocationStateData>(false);

   const action = async (): Promise<void> => {
      const patient = await performCqrsQueryGet<PatientSimple>(
         () => {
            const query = new PatientSimpleQuery();
            query.id = Slot.of(props.patientId);
            return query;
         },
         {
            cacheTime: 'never',
         }
      );

      if (patient.referenceIdentifier) {
         return Promise.resolve();
      }

      dispatchSnackbarPositiveEvent(translationKeys.completePatientDataBeforeStartingVisit);

      push(getTemporaryPatientFilePath(props.patientId), {
         data: {
            appointmentId: props.appointmentId,
            showAppointmentOutOfSchedule: false,
         },
         label: props.goBackButtonLabel,
         preventPrompt: PreventPrompt.ALWAYS,
      });

      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject();
   };

   return <ActionEventInterceptor action={action}>{props.children}</ActionEventInterceptor>;
};
